import React, { useRef, useEffect } from "react";

// React wrapper for Om Design System Form web component
const OmForm = React.forwardRef(({ 
  children,
  onSubmit,
  id,
  descriptionText,
  titleText,
  submitButtonIconTrailing = false,
  useInlineActions = "false",
  hideSubmitButton = false,
  submitButtonLabel,
  formId,
  isLoading = false,
  ...props 
}, ref) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const handleSubmit = (event) => {
      if (onSubmit) {
        onSubmit(event);
      }
    };

    element.addEventListener('submit', handleSubmit);
    
    return () => {
      if (element) {
        element.removeEventListener('submit', handleSubmit);
      }
    };
  }, [onSubmit]);

  return (
    <omk-form
      ref={(el) => {
        elementRef.current = el;
        if (ref) {
          if (typeof ref === 'function') {
            ref(el);
          } else {
            ref.current = el;
          }
        }
      }}
      id={id}
      form-id={formId}
      description-text={descriptionText}
      title-text={titleText}
      submit-button-icon-trailing={submitButtonIconTrailing}
      submit-button-label={submitButtonLabel}
      hide-submit-button={hideSubmitButton}
      use-inline-actions={useInlineActions}
      loading={isLoading}
      {...props}
    >
      {children}
    </omk-form>
  );
});

OmForm.displayName = 'OmForm';

export default OmForm;
